<!--
 * @Description: 停水降压通知
--> 
<template>
  <div class="butler-serve">
    <van-nav-bar left-text="返回" :title="title" @click-left="$comm.onClickLeft" v-show="$comm.titleShow()" left-arrow fixed>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <van-swipe class="my-swipe" :autoplay="3000" height="147">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" width="100%" height="100%" />
      </van-swipe-item>
      <div class="butler-title">
        <div class="mytit">通知公告</div>
        <div class="stick">NOTICE NOTICE</div>
      </div>
    </van-swipe>
    <van-tabs color="#1677FF" v-model="active" @change="onChange" sticky>
      <van-tab v-for="(tab, i) in tabs" :key="i" :title="tab.title">
        <div class="comm-seperator"></div>
        <article-list :typecode="typeCode" :title="tab.title"></article-list>
      </van-tab>
    </van-tabs>
    <home-bar></home-bar>
    <div class="comm-homebar-height"></div>
  </div>
</template>

<script>
// import MustKnowItem from '../guide/MustKnowItem'
import ArticleList from './ArticleList'
import HomeBar from '@/components/HomeBar.vue'
export default {
  name: 'ButlerServe',
  components: {
    ArticleList,
    HomeBar
  },
  data() {
    return {
      images: [
        require('../../assets/images/tonggao.png')
      ],
      title: '',
      active: 0,
      typeCode: 202,
      articleList: [],
      tabs: [
        {
          title: '停水公告'
        },
        {
          title: '水质公告'
        },
        {
          title: '服务公告'
        }
      ]
    }
  },
  mounted() {
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active)
    }
    this.onChange(this.active)
  },
  methods: {
    onChange(value) {
      if (value === 0) {
        this.typeCode = 114 // 停水降压
        this.title = '停水公告'
      } else if (value === 1) {
        this.typeCode = 115 // 水质公告
        this.title = '水质公告'
      } else if (value === 2) {
        this.typeCode = 125 // 服务公告
        this.title = '服务公告'
      }
      this.getAgreeList()
    },
    getAgreeList() {
      let params = {
        "typecode": this.typeCode,
        "pagesize": 20,
        "pageindex": 1
      }
      this.$http.post(this.$api.getArticles, params).then(res => {
        if (res.code === '000') {
          this.articleList = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.butler-serve {
  .seperator {
    height: 7px;
  }
  .sales-net-list {
    padding: 0 16px;
  }
}
.butler-title {
  top: 50%;
}
.mytit {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #f6f6f6;
  margin-bottom: 10px;
  text-shadow: 2px 2px 2px #2f6deb;
}
.stick {
  background: linear-gradient(180deg, #4e8ffd 0%, #5964fb 100%);
  border-radius: 11px;
  opacity: 0.96;
  width: 35%;
  font-size: 10px;
  margin: 0 auto;
}
</style>